import { logger } from '@/modules/common/logging/logger';

import { BaseNotification } from '../helpers/types';
import { INotificationService } from './INotificationService';

export class NotificationServiceLogDecorator implements INotificationService {
  private decoree: INotificationService;

  constructor(decoree: INotificationService) {
    this.decoree = decoree;
  }

  addNotification(notification: BaseNotification): void {
    const start = this.logStart('addNotification');
    this.decoree.addNotification(notification);
    this.logEnd('addNotification', start);
  }

  setPanelState(open: boolean): void {
    const start = this.logStart('setPanelState');
    this.decoree.setPanelState(open);
    this.logEnd('setPanelState', start);
  }

  // private utility methods

  private logStart(methodName: string): number {
    const start: number = performance.now();
    logger.info(`Start -> ${methodName}`);
    return start;
  }

  private logEnd(methodName: string, start: number): void {
    logger.info(`End -> ${methodName} (${(performance.now() - start).toFixed(2)}ms)`);
  }
}
